import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Table, TableBody, Typography } from '@mui/material';
import { generateMongoDBId } from 'console/utils/mongo-db';
import { useCallback, useState } from 'react';
import { TableAddItem, TableHeadItem, TableNoData, TableRowItem } from './table-pattern';
import { AddBox, Close } from '@mui/icons-material';
const defaultHistory = {
    id: '-1',
    name: '',
    materials: '',
    operations: '',
    price: '',
    performed: {
        date: 0,
        mileage: null,
        moto_hours: null,
    },
    attachments: [],
};
export const HistoryMaintenanceTable = ({ toggleHistory, setToggleHistory, device_id, maintenances, setReverseToggleHistory, save_device_settings, }) => {
    const [historyList, setHistoryList] = useState(maintenances?.history);
    const FuncDeleteHistoryItem = useCallback((history_id) => {
        if (maintenances && historyList) {
            const index = historyList?.findIndex((el) => el.id === history_id);
            setHistoryList([
                ...historyList.slice(0, index),
                ...historyList.slice(index + 1),
            ]);
            save_device_settings({
                maintenances: {
                    ...maintenances,
                    history: [
                        ...historyList.slice(0, index),
                        ...historyList.slice(index + 1),
                    ],
                },
            });
        }
    }, [maintenances, historyList, save_device_settings]);
    const CreateDefaultMaintenances = useCallback((history) => {
        save_device_settings({
            maintenances: {
                planned_notification: maintenances?.planned_notification ?? null,
                history: history,
            },
        });
    }, [save_device_settings, maintenances]);
    const FuncAddHistoryItem = useCallback((name, date) => {
        const newHistoryItem = {
            ...defaultHistory,
            id: device_id + '-' + generateMongoDBId().slice(-5),
            name: name.length !== 0 ? name : 'Плановое',
            performed: {
                ...defaultHistory.performed,
                date: date,
            },
        };
        if (historyList) {
            setHistoryList([...historyList, newHistoryItem]);
            CreateDefaultMaintenances([...historyList, newHistoryItem]);
        }
        else {
            setHistoryList([newHistoryItem]);
            CreateDefaultMaintenances([newHistoryItem]);
        }
        if (maintenances && historyList) {
            save_device_settings({
                maintenances: {
                    ...maintenances,
                    history: [...historyList, newHistoryItem],
                },
            });
        }
    }, [
        defaultHistory,
        save_device_settings,
        historyList,
        CreateDefaultMaintenances,
        maintenances,
    ]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, width: "100%", children: [_jsxs(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [_jsx(Typography, { variant: "h6", children: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F" }), _jsx(Button, { variant: "outlined", color: "primary", startIcon: toggleHistory ? _jsx(Close, {}) : _jsx(AddBox, {}), size: "small", onClick: setReverseToggleHistory, sx: { mt: 2, flexShrink: 0 }, children: toggleHistory ? 'Закрыть' : 'Добавить' })] }), _jsxs(Table, { children: [_jsx(TableHeadItem, { columns: ['Название', 'Дата выполнения'], toogleFlag: toggleHistory }), _jsxs(TableBody, { children: [toggleHistory && (_jsx(TableAddItem, { setToogleFlag: setToggleHistory, FuncAddItem: FuncAddHistoryItem })), historyList && historyList.length !== 0
                                ? historyList.map((el) => (_jsx(TableRowItem, { name: el.name, idItem: el.id, date: el.performed.date, toogleFlag: toggleHistory, FuncDeleteItem: FuncDeleteHistoryItem }, el.id)))
                                : !toggleHistory && _jsx(TableNoData, {})] })] })] }));
};
